import { Offering, CriticalityPath } from './types'
import { Module, BundleGroupSelection, SapKey } from '../../../../types/types'

// This datatype is for signaling what updates needs to be
// done to the dependencies after a domain event happens.
//
// * NoOp: no changes required
// * ValidateAll: dependencies should be recalculated for all groups and interaction
// * ValidateGroup: dependencies should be recalculated for one group only and interaction
export type StateChange = NoOp | ValidateAll | ValidateGroup | ValidateBundle

export class NoOp {
  readonly _tag: 'UpdateNothing' = 'UpdateNothing' as const

  constructor(
    readonly offering: Offering,
    readonly error: StateUpdateError | null = null
  ) {}
}

export class ValidateAll {
  readonly _tag: 'UpdateAll' = 'UpdateAll' as const

  constructor(readonly offering: Offering) {}
}

/**
 * Represents a validation for bundle selections.
 */
export class ValidateBundle {
  readonly _tag: 'UpdateBundleSelections' = 'UpdateBundleSelections' as const

  /**
   * Creates a new instance of the ValidateBundle class.
   * @param offering - The offering associated with the bundle selection.
   * @param path - The criticality path for the bundle selection.
   * @param bundleServiceSelectionChange - The change in bundle service selection.
   */
  constructor(
    readonly offering: Offering,
    readonly path: CriticalityPath,
    readonly bundleServiceSelectionChange: BundleGroupSelection
  ) {}
}
export class ValidateGroup {
  readonly _tag: 'UpdateGroup' = 'UpdateGroup' as const

  constructor(
    readonly path: CriticalityPath,
    readonly changedModule: Module,
    readonly offering: Offering
  ) {}
}

export class BundleUpdateError extends Error {
  readonly _tag = 'BundleUpdateError' as const

  constructor(
    readonly keys: SapKey[],
    readonly data: { bundleKey: string; groupId: string },
    readonly message: string
  ) {
    super(message)
  }
}
BundleUpdateError.prototype.name = 'BundleUpdateError'

export type StateUpdateError = BundleUpdateError
